import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var sampleSchema = {
    bg_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на български*',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    en_name: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Име на английски*',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име',
    }),
    packaging: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Опаковка *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидна опаковка',
    }),
    brand: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'Бранд *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валидно име на бранд',
    }),
    status: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            options: [],
        }),
        elementType: 'dropdown',
        label: 'Статус *',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валиден статус',
    }),
    position: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
        }),
        elementType: 'input',
        label: 'Позиция',
        value: 50,
        validation: {
            required: false,
        },
        valid: true,
        touched: false,
        errorMsg: 'Моля, въведете валидна позиция',
    }),
    image_url: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'image',
        label: 'Картинка *',
        value: null,
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете валиден адрес',
    }),
    external_id: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'text',
        }),
        elementType: 'input',
        label: 'ERP ID*',
        value: '',
        validation: {
            required: true,
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въвдете ERP ID',
    }),
};
export default sampleSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/sampleSchema.ts
// module id = 448
// module chunks = 0